import axios from "axios";

// Empty in production: the SPA and the API are served from the same origin, so
// every call is a relative "/api/..." request and no cross-origin setup is
// needed. Only set REACT_APP_BACKEND_URL when the API lives somewhere else.
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";

export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  timeout: 15000,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("3duo_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Image references come back from the API as absolute URLs (external stock
// photos) or as site-relative paths such as "/media/products/<uuid>.jpg".
export const resolveImg = (url) => {
  if (!url) return "";
  if (url.startsWith("http")) return url;
  return `${BACKEND_URL}${url}`;
};
